import api from '../token';

export const AddFormaPagamento = async (dados) => {
  try {
    const response = await api.post('/addFormaPagamento', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};


